/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import './styles.scss';
import Skeleton from 'react-loading-skeleton';
import DefaultProfile from '../../assets/profile/default-profile-icon.svg';
import ProfileArt from '../../assets/profile/Group2.png';
import Back from '../../assets/profile/back.png';
import Edit from '../../assets/profile/edit-icon.svg';

class ProfilePage extends Component {
  async componentDidMount() {
    if (!this.props.showOther) {
      await this.props.getAnswers();
      await this.props.getProfilePhoto(this.props.surveyAnswers.profile_photo?.answer);
    }
  }

  findAnswer = (name) => {
    return (
      (this.props.surveyAnswers[name]?.answer)
        ? this.props.surveyAnswers[name].answer
        : '[This question has not been answered yet]'
    );
  };

  getEmail = (user) => {
    return (
      (this.props.email)
        ? this.props.email
        : '[The email is not there]'
    );
  };

  editProfile = (e) => {
    e.stopPropagation();
    this.props.history.push('/survey');
  };

  renderSlider = (question, i, answer) => {
    const scores = Array.from({ length: 5 }, (x, j) => j - 2);
    const opt1 = question.options[0];
    const opt2 = question.options[1];
    const selectedVal = answer;
    return (
      <div key={i}>
        <p className="surveyOptionTitle">{question.title}</p>
        <div className="profileSurveyOptionContainer">
          <div className="slider-box">
            <p className="profileSurveyOptionText">{opt1}</p>
            <div className="bubbleContainer">
              {scores.map((val) => {
                let className;
                switch (Math.abs(val)) {
                  case 2:
                    className = 'slider-bubble-big';
                    break;
                  case 1:
                    className = 'slider-bubble-med';
                    break;
                  default:
                    className = 'slider-bubble-small';
                }
                return (
                  <div role="button" tabIndex={0} key={val} className={`slider-bubble ${className} ${selectedVal === String(val) && 'surveySelected'}`} />
                );
              })}
            </div>
            <p className="profileSurveyOptionText">{opt2}</p>
          </div>
        </div>
      </div>
    );
  };

  renderGeneralAnswer = (q, i, a) => {
    let answer = a;
    if (!answer || answer === 'null') answer = undefined;
    return (
      <div key={i}>
        <div className="about-section">{q.title}</div>
        <div className="about-answer">
          {typeof (answer) === 'string'
            ? answer
            : (answer === undefined || answer.length === 0 || (answer.length > 0 && answer[0] === 'null'))
              ? '[did not answer]'
              : Array.from(answer).join(', ')
          }
        </div>
      </div>
    );
  };

  getProfilePhoto = (url) => {
    if (!url) {
      return (
        <div
          className="profile-circle"
          style={{ backgroundImage: `url(${DefaultProfile})` }}
        />
      );
    }
    if (!url.startsWith('http')) {
      return (
        <div className="profile-circle">
          <Skeleton circle height="100%" width="100%" />
        </div>
      );
    } else {
      return (
        <div
          className="profile-circle"
          style={{ backgroundImage: `url(${url})` }}
        />
      );
    }
  }

  render() {
    const locationKey = this.props.userType === 1 ? 'house' : 'location';
    return (
      <div className="full-page">
        <div className="column-page">
          <div className="left-side">
            { this.props.showOther && <img className="back-arrow" src={Back} alt="Back" onClick={this.props.location.backFunction} /> }
            {this.getProfilePhoto(this.props.surveyAnswers.profile_photo?.answer)}
            <img id="profile-art" src={ProfileArt} alt="Profile" />
          </div>
          <div className="profile-right-side">
            { !this.props.showOther && (
            <button type="button" onClick={this.editProfile}>
              Edit Profile
              <img src={Edit} alt="edit" />
            </button>
            )}
            <div className="basics">
              <div className="person-name">{this.props.name} </div>
              <div className="class-year-house">Class of {this.findAnswer('year_of_graduation')} | {this.findAnswer(locationKey)} | {this.getEmail()} </div>
              <div className="short-bio">
                <div id="short-bio">{this.findAnswer('bio')}</div>
              </div>
            </div>
            <div className="bottom-half">
              <div className="profile-subsection-container about">
                <div className="profile-page-subheader">About</div>
                <div className="profile-subsection-box">
                  {
                    Object.keys(this.props.surveyQuestions).map((name, i) => {
                      const q = this.props.surveyQuestions[name];
                      const answer = this.props.surveyAnswers[name]?.answer;
                      return (((q.type === 'multiple' || q.type === 'checkbox') && name !== 'house' && name !== 'year_of_graduation')
                        && this.renderGeneralAnswer(q, i, answer));
                    })
                  }
                </div>
              </div>
              <div className="profile-subsection-container">
                <div className="profile-page-subheader">Preferences</div>
                <div className="profile-subsection-box">
                  {
                    Object.keys(this.props.surveyQuestions).map((name, i) => {
                      const q = this.props.surveyQuestions[name];
                      const answer = this.props.surveyAnswers[name]?.answer;
                      return (q.type === 'slider' && this.renderSlider(q, i, answer));
                    })
                  }
                </div>
              </div>
              <div className="profile-subsection-container additional-info">
                <div className="profile-page-subheader">Additional Info</div>
                <div className="profile-subsection-box">
                  {
                    Object.keys(this.props.surveyQuestions).map((name, i) => {
                      const q = this.props.surveyQuestions[name];
                      const answer = this.props.surveyAnswers[name]?.answer;
                      return ((q.type === 'short' && name !== 'bio')
                        && this.renderGeneralAnswer(q, i, answer));
                    })
                  }
                  <div className="care-about">I Care About:
                    <div className="care-about-box">
                      {
                        Object.keys(this.props.surveyAnswers).map((name) => {
                          const q = this.props.surveyAnswers[name];
                          const answers = q.answer;
                          return (name.includes('question_importance') && answers
                              && Array.from(q.answer).map(answer => <div className="boxTag" key={answer}>{answer}</div>)
                          );
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProfilePage;
